<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 0C11.7391 0 10.9955 0.0705331 10.2744 0.206347C9.18184 0.411193 8.14182 0.763858 7.17609 1.24258C3.21936 3.20475 0.5 7.28516 0.5 12.0004C0.5 18.6275 5.87194 24 12.5 24C19.1273 24 24.5 18.6275 24.5 12.0004C24.5 5.37252 19.1273 0 12.5 0ZM12.4895 3.47563C14.4855 3.47563 16.3179 4.17946 17.7556 5.35526C19.1746 6.51455 20.2094 8.13231 20.6378 9.98493H16.2631C15.548 8.59753 14.1111 7.65059 12.4542 7.65059C10.0845 7.65059 8.16283 9.58949 8.16283 11.9824C8.16283 12.4701 8.24237 12.9383 8.38944 13.3758C8.40145 13.4103 8.41346 13.4448 8.42621 13.4786C7.23087 12.6067 6.46773 11.283 6.46773 9.80109C6.46773 9.01172 6.68384 8.26812 7.06653 7.61307C7.16333 7.44649 7.27139 7.28591 7.38919 7.13209L6.32891 6.20391C7.85743 4.52687 10.0515 3.47563 12.4895 3.47563ZM12.4895 20.3473C8.00375 20.3473 4.34342 16.7891 4.13257 12.3208C5.36618 15.0528 7.9017 16.9257 10.8274 16.9257C13.1791 16.9257 15.2771 15.7161 16.6511 13.8237H20.6416C19.7824 17.5612 16.4582 20.3473 12.4895 20.3473Z"
      :fill="resolvedColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CashiaAppLogo",
  props: {
    color: {
      type: String,
      default: "white",
      validator: value => ["white", "pink"].includes(value)
    }
  },
  computed: {
    resolvedColor() {
      return this.color === "white"
        ? "var(--always-white)"
        : "var(--bg-rose-600)";
    }
  }
};
</script>
